import * as tslib_1 from "tslib";
import { updateUserOptions } from 'owa-options-core';
import { saveCalendarMailboxConfiguration, updateCalendarMailboxConfiguration, } from 'owa-calendar-configuration';
import { getUserConfiguration } from 'owa-session-store';
import getWeekStartDay from '../selectors/getWeekStartDay';
import getTimeIncrement from '../selectors/getTimeIncrement';
import getWorkDays from '../selectors/getWorkDays';
import getShowWeekNumbers from '../selectors/getShowWeekNumbers';
import getFirstWeekOfYear from '../selectors/getFirstWeekOfYear';
import getWorkingHoursStartTime from '../selectors/getWorkingHoursStartTime';
import getWorkingHoursEndTime from '../selectors/getWorkingHoursEndTime';
import updateSurfaceOptions from '../data/actions/updateSurfaceOptions';
import logDataOnSaveAppearance from '../utils/logDataOnSaveAppearance';
/**
 *  Called when clicked on Save button in calendar settings panel.
 *  Updates user options so that the changes are reflected in current user session
 *  Updates the calendar configuration on local store and on server
 */
function saveAppearanceOption() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var WeekStartDay, TimeIncrement, WorkDays, ShowWeekNumbers, FirstWeekOfYear, WorkingHoursStartTime, WorkingHoursEndTime, partialCalendarMailboxConfiguration;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    WeekStartDay = getWeekStartDay();
                    TimeIncrement = getTimeIncrement();
                    WorkDays = getWorkDays();
                    ShowWeekNumbers = getShowWeekNumbers();
                    FirstWeekOfYear = getFirstWeekOfYear();
                    WorkingHoursStartTime = getWorkingHoursStartTime();
                    WorkingHoursEndTime = getWorkingHoursEndTime();
                    updateUserOptions({
                        WeekStartDay: WeekStartDay,
                        HourIncrement: TimeIncrement,
                        WorkingHours: tslib_1.__assign({}, getUserConfiguration().UserOptions.WorkingHours, { WorkHoursStartTimeInMinutes: WorkingHoursStartTime, WorkHoursEndTimeInMinutes: WorkingHoursEndTime, WorkDays: WorkDays }),
                        ShowWeekNumbers: ShowWeekNumbers,
                        FirstWeekOfYear: FirstWeekOfYear,
                    });
                    partialCalendarMailboxConfiguration = {
                        WeekStartDay: WeekStartDay,
                        TimeIncrement: TimeIncrement,
                        WorkDays: WorkDays,
                        ShowWeekNumbers: ShowWeekNumbers,
                        FirstWeekOfYear: FirstWeekOfYear,
                        WorkingHoursStartTime: WorkingHoursStartTime,
                        WorkingHoursEndTime: WorkingHoursEndTime,
                    };
                    updateCalendarMailboxConfiguration(partialCalendarMailboxConfiguration);
                    /**
                     * Action dispatched to call an orchestrator in owa-calendar which will initialize surface options.
                     */
                    updateSurfaceOptions();
                    return [4 /*yield*/, saveCalendarMailboxConfiguration(partialCalendarMailboxConfiguration)];
                case 1:
                    _a.sent();
                    logDataOnSaveAppearance();
                    return [2 /*return*/];
            }
        });
    });
}
export default saveAppearanceOption;
//# sourceMappingURL=saveAppearanceOption.js.map